module.exports = __webpack_public_path__ + "img/cats2.a689bcb1.jpg";